import t from './strings'

export const bulletPointsUS = [
  t.bulletText1(),
  t.bulletText2(),
  t.bulletText3(),
  t.bulletText4(),
  t.bulletText5(),
  t.bulletText6(),
  t.bulletText7(),
]

export const bulletPointsCA = [
  t.bulletText1(),
  t.bulletText2(),
  t.bulletText3(),
  t.bulletText4(),
  t.bulletText5(),
  t.bulletText6(),
  t.bulletText7(),
]

export const bulletPointsAUS = [
  t.bulletText1(),
  t.bulletText2(),
  t.bulletText3(),
  t.bulletText4(),
  t.bulletText5(),
  t.bulletText6(),
  t.bulletText7(),
]
